import http from "../http-common";

class DataManagementService {
  getMergeCandidates() {
    return http.get("/data-management/merge-candidates");
  }

  getRecentMerges() {
    return http.get("/data-management/recent-merges");
  }

  previewMerge(winnerPersonId, loserPersonId, fieldPolicyMode = 'recency') {
    return http.get("/data-management/merge-preview", { params: { winnerPersonId, loserPersonId, fieldPolicyMode } });
  }

  performMerge(winnerPersonId, loserPersonId, candidateId = null, fieldPolicyMode = 'recency') {
    return http.post("/data-management/merge", { winnerPersonId, loserPersonId, candidateId, fieldPolicyMode });
  }

  undoMerge(mergeId) {
    return http.post(`/data-management/merge/${mergeId}/undo`);
  }

  dismissCandidate(candidateId) {
    return http.post(`/data-management/candidates/${candidateId}/dismiss`);
  }
}

export default new DataManagementService();
